import React from "react";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import SlideshowIcon from "@material-ui/icons/Slideshow";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Link from "@material-ui/core/Link";
import { convertNumbersInStringToPersian } from "../helpers/language";
import {
  Theme,
  createStyles,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";

interface FilePropsInterface {
  src: string;
  index: number;
  topic: string;
  video: { src: string; title: string };
  setVideo: (video: { src: string; title: string; topic: string }) => void;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flexContainer: {
      display: "flex",
      alignItems: "center",
      padding: "0 0 10px 0",
    },
  })
);

export default function File(props: FilePropsInterface) {
  const { src, index, video, setVideo, topic } = props;
  const classes = useStyles();
  const handleClick = (title: string, topic: string) => {
    setVideo({ src, title, topic });
  };
  return (
    <div className={classes.flexContainer}>
      <PlayCircleFilledIcon color="primary" fontSize="small" />
      <Link
        href={src}
        onClick={(event: React.SyntheticEvent) => {
          event.preventDefault();
          handleClick(
            ` ویدیو ${convertNumbersInStringToPersian((index + 1).toString())}`,
            topic
          );
        }}
      >
        {/*  {` ویدیو ${convertNumbersInStringToPersian((index + 1).toString())}`} */}
        {` ویدیو`}
      </Link>
      &nbsp;&nbsp;&nbsp;&nbsp;
    </div>
  );
}
